var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversalScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bca8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#a966c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9834c4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.40381,50.00002c0-2.87155-1.32375-5.43185-3.39198-7.11085.15068-.65892.23773-1.34193.23773-2.04652,0-4.47751-3.21556-8.19834-7.46211-8.99423-1.22773-3.61005-4.63868-6.21104-8.66398-6.21104-5.05747,0-9.15736,4.09989-9.15736,9.15736v3.0384h-8.39653v-4.01219c1.47399-.67876,2.49939-2.16508,2.49939-3.89424,0-2.36894-1.9204-4.28934-4.28934-4.28934s-4.28929,1.9204-4.28929,4.28934c0,1.72912,1.02531,3.21539,2.49926,3.89419v7.59221h11.97651v6.79707h-14.18625c-.67872-1.47408-2.16512-2.49952-3.89437-2.49952-2.3689,0-4.28929,1.9204-4.28929,4.28934s1.9204,4.28929,4.28929,4.28929c1.72907,0,3.21539-1.02531,3.89419-2.49913h14.18643v6.79637h-11.97651v7.59252c-1.47395.67881-2.49926,2.16508-2.49926,3.89424,0,2.3689,1.9204,4.28929,4.28929,4.28929s4.28934-1.9204,4.28934-4.28929c0-1.7292-1.0254-3.21552-2.49939-3.89428v-4.01249h8.39653v3.03875c0,5.05743,4.09989,9.15727,9.15736,9.15727,4.0253,0,7.43624-2.60095,8.66398-6.211,4.24655-.79588,7.46211-4.51667,7.46211-8.99423,0-.70459-.0871-1.38759-.23778-2.04656,2.06828-1.67895,3.39203-4.23926,3.39203-7.11076Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalScraper);
export default __webpack_public_path__ + "static/media/universal-scraper.9e88754e02753ca1193d5db87758ddce.svg";
export { ForwardRef as ReactComponent };